import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,  InputLabel, MenuItem,
    Select,
    TextField
} from "@mui/material";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {useSnackbar} from "notistack";
import {SelectChangeEvent} from "@mui/material/Select";
import Box from "@mui/material/Box";
import {MenuProps} from "../../Utils/PropsStyles";
import ConfirmDialog from "./ConfirmDialog";
interface ParamsModalProps {
    open: boolean;
    onCloseModal: any;
    commandDTO: CommandDTO;
}
export interface CommandDTO {
    id: number;
    teleObjectName: string;
    userId: number;
    point: number;
    teleObjectSpecType: number;
    etsCode: number;
    brokerId: number;
    powerStationName?: string;
    skidName?: string | null;
    equipmentName?: string;
    commandValues?: any;
    confirmation: boolean;
}
export const ModalForSendingTelecommand = ({open, onCloseModal, commandDTO}: ParamsModalProps) => {
    const { enqueueSnackbar } = useSnackbar();

    const [commandConfirm, setCommandConfirm] = useState(false);
    const getSingleCommandValue = () => {
        const commandValues = commandDTO?.commandValues;
        return Array.isArray(commandValues) && commandValues.length === 1 ? commandValues[0] : undefined
    }

    const getInitialCommandValue = () => {
        return getSingleCommandValue()?.value ?? ""
    }

    const getInitialCommand = () => {
        return (getSingleCommandValue()?.name as string) ?? ""
    }

    const getInitialCommandId = () => {
        return getSingleCommandValue()?.id ?? null
    }

    const [inputValue, setInputValue] = useState(getInitialCommandValue());
    const [selectedCommand, setSelectedCommand] = useState(getInitialCommand());
    const [selectCommandId, setSelectCommandId] = useState(getInitialCommandId());

    useEffect(() => {
        setInputValue(getInitialCommandValue())
        setSelectedCommand(getInitialCommand())
    }, [onCloseModal]);

    const handleSelectTeleCommandValue = (event: SelectChangeEvent<unknown>) => {
        setSelectedCommand(event.target.value as string);
        let commandValue = commandDTO?.commandValues?.find((cmd: any) => cmd.name === event.target.value);
        if (commandValue != null) {
            setInputValue(commandValue.value);
            setSelectCommandId(commandValue.id);
        }
    }

    const sendCommand = async () => {
        if(commandDTO?.confirmation === false){
            handleSend()
        }
        setCommandConfirm(commandDTO?.confirmation ?? true)
    }


    const handleSend = async () => {
        if (commandDTO && inputValue != null) {
            if (!/^\d+$/.test(inputValue)) {
                enqueueSnackbar("Apenas valores numéricos são aceitos!", {variant: "error"});
                handleCloseCommandConfirm()
                return;
            }
            if(commandDTO.teleObjectSpecType === 5 && Number(inputValue) > 1){
                enqueueSnackbar("Apenas os valores 0 e 1 são aceitos!", {variant: "error"});
                handleCloseCommandConfirm()
                return;
            }
            try {
                await axios.post('/api/send-command', {
                    userId: commandDTO.userId,
                    teleObjectId: commandDTO.id,
                    point: commandDTO.point,
                    teleObjectSpecType: commandDTO.teleObjectSpecType,
                    etsCode: commandDTO.etsCode,
                    data: Number(inputValue),
                    brokerId: commandDTO.brokerId,
                    commandValueId: selectCommandId
                });
                enqueueSnackbar("Valor enviado com sucesso!", { variant: "success" });
                setSelectCommandId(null);
                setSelectedCommand("");
            } catch (error) {
                // @ts-ignore
                enqueueSnackbar(`Erro ao enviar o comando: ${error.response.data.detail}`, {variant: "error"});
                console.error("Erro ao enviar comando. Tente novamente:", error);
            }
            handleCloseCommandConfirm()
            onCloseModal()
        }
    };

    const handleCommandConfirm = async ( ) => {
        handleSend();
    }

    const handleCloseCommandConfirm = async ( ) => {
        setCommandConfirm(false)
    }

    const printFullHeader = () => {
        return commandDTO?.skidName != null && commandDTO?.powerStationName != null && commandDTO?.equipmentName != null
    }
    return (
        <Dialog
            PaperProps={{
                sx: (theme) => ({
                    width: '50%', // largura padrão para telas pequenas
                    maxWidth: '600px', // limite superior para telas grandes
                    [theme.breakpoints.up('sm')]: {
                        width: '30%',
                    },
                    [theme.breakpoints.up('md')]: {
                        width: '25%',
                    },
                    [theme.breakpoints.up('lg')]: {
                        width: '25%',
                    },
                    [theme.breakpoints.up('xl')]: {
                        width: '15%',
                    },
                }),
            }}
            open={open}
            onClose={onCloseModal}>

            {printFullHeader() ?
                <DialogTitle>{commandDTO?.equipmentName + ' - ' + commandDTO?.skidName + ' - ' + commandDTO?.powerStationName}</DialogTitle>
            :   <DialogTitle>{commandDTO?.teleObjectName}</DialogTitle>
            }
            <DialogContent>
                {printFullHeader() && <DialogContentText>{commandDTO?.teleObjectName}</DialogContentText>}
                {
                        (commandDTO?.commandValues && commandDTO?.commandValues.length > 0) ?
                            <Box>
                                <InputLabel id="valueCommand" sx={{fontSize: '.8rem'}}>Selecione o Valor</InputLabel>
                                <Select
                                    fullWidth
                                    labelId="valueCommand"
                                    id="valueCommand"
                                    placeholder="Selecione o valor"
                                    value={selectedCommand}
                                    label="Selecione o valor"
                                    title="Selecione o valor"
                                    onChange={(value) => handleSelectTeleCommandValue(value)}
                                    variant={"standard"}
                                    MenuProps={MenuProps}
                                >
                                    {commandDTO.commandValues.map((item: any, index: number) =>
                                        <MenuItem
                                            sx={{
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-word',
                                            maxWidth: '100%',
                                            }}
                                            key={index} value={item.name}>{`Nome: ${item.name}, Valor: ${item.value}`}</MenuItem>)}
                                </Select>
                            </Box>
                            :
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Digite o valor"
                            type="text"
                            fullWidth
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                        />
                }

            </DialogContent>
            <DialogActions>
                <Button onClick={onCloseModal} color="primary">
                    Cancelar
                </Button>
                <Button onClick={sendCommand} color="primary" variant="contained" disabled={inputValue === ""}>
                    Enviar
                </Button>
            </DialogActions>
            <ConfirmDialog
                title={'Enviar'}
                description={'Deseja enviar esse comando?'}
                open={commandConfirm}
                handleConfirm={handleCommandConfirm}
                handleClose={handleCloseCommandConfirm}

            />
        </Dialog>
    )
}